document.addEventListener('DOMContentLoaded', function () {

  //Add active item classes
  let accordion = document.querySelectorAll('.paragraph-accordions .accordion-item');

  accordion.forEach(function (element) {
    //console.log(element.offsetTop);
    let accId = element.querySelector('.accordion-collapse.collapse').id;

    let accNewId = accId.replace(/\s+/g, '-').toLowerCase();

    element.querySelector('.accordion-collapse.collapse').setAttribute('id', accNewId);
    element.querySelector('.accordion-button').setAttribute('data-bs-target', '#'+accNewId);
  });

}, false);
